import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';

export const useDeleteTraining = () => {
  const { user } = useAuth();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteTraining = async (trainingId: string): Promise<{ success: boolean; error?: string }> => {
    if (!user) {
      return { success: false, error: 'User not authenticated' };
    }

    setIsDeleting(true);

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) {
        throw new Error('No valid session found');
      }

      const { getEdgeFunctionUrl } = await import('@/utils/url');
      const functionUrl = getEdgeFunctionUrl('delete_training');
      
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({
          training_id: trainingId
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to delete training');
      }

      return { success: true };
    } catch (error) {
      console.error('Error deleting training:', error);
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Failed to delete training' 
      };
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteTraining,
    isDeleting
  };
}; 